import type { IRootState } from '../root-reducer';

export const getIsIdentifyUserSent = (state: IRootState) => state.iam.isIdentifyUserSent;
export const getIsOtpValid = (state: IRootState) => state.iam.isOtpValid;
export const getInvalidPasswordError = (state: IRootState) => state.iam.invalidPasswordError;
export const getIsNewPasswordSaved = (state: IRootState) => state.iam.isNewPasswordSaved;
export const getIsPasswordResetCancelled = (state: IRootState) => state.iam.isPasswordResetCancelled;
